import React from 'react';

import styled from '@emotion/styled';

import Img from '../Img/Img';
import { ToggleButton } from '../ToggleButton/ToggleButton';
import {
  extractTextFromHTML,
  salaryInterval,
  truncateText,
  truncateTextByCharacters,
} from '../../utils/utils';

export interface IPostedJobsCard {
  imgSrc?: string;
  title: string;
  description: string;
  pay: number;
  startDate: string;
  endDate: string;
  payInterval: string;
}

const PostedJobsCard: React.FC<IPostedJobsCard> = ({
  imgSrc,
  title,
  description,
  pay,
  startDate,
  endDate,
  payInterval,
}) => {
  return (
    <Container>
      <UpperSection>
        <ImageContainer>
          <Img
            src={imgSrc ?? '/static/gif/happyAnimal.gif'}
            alt="shift location image"
          />
        </ImageContainer>
        <div>
          <UpperSectionTitle>{title}</UpperSectionTitle>
          <UpperSectionDescription>
            {' '}
            {(() => {
              const text = extractTextFromHTML(description);
              const first20 = text.slice(0, 20);
              const spaceCount = (first20.match(/ /g) || []).length;
              return spaceCount < 4
                ? truncateTextByCharacters(text, 40)
                : truncateText(text, 9);
            })()}
          </UpperSectionDescription>
        </div>
        <ToggleButton controller={() => console.log('Toggle')} />
      </UpperSection>
      <BottomSection>
        <FlexContainer>
          <BottomSectionLabel>Contract Period</BottomSectionLabel>
          <BottomSectionLabel>Pay</BottomSectionLabel>
        </FlexContainer>
        <FlexContainer>
          <BottomSectionData>
            {startDate ? new Date(startDate).toLocaleDateString() : 'N/A'} -{' '}
            {endDate ? new Date(endDate).toLocaleDateString() : 'N/A'}
          </BottomSectionData>
          <BottomSectionData>
            {pay.toLocaleString('en-NG', {
              style: 'currency',
              currency: 'NGN',
            })}
            /{salaryInterval[payInterval]}
          </BottomSectionData>
        </FlexContainer>
      </BottomSection>
    </Container>
  );
};

export default PostedJobsCard;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  color: black;
  border-radius: 0.25rem;
  background-color: ${({ theme }) => theme.palette.backgroundColor};
`;

const UpperSection = styled.div`
  display: grid;
  grid-template-columns: 50px auto 34px;
  gap: 0.5rem;
  padding: 0.875rem;
`;

const UpperSectionTitle = styled.div`
  font-size: 1.25rem;
  font-weight: 400;
  line-height: normal;
`;

const UpperSectionDescription = styled.div`
  font-size: 0.872rem;
  font-weight: 300;
  color: ${({ theme }) => theme.palette.greyGrey1};
`;
const ImageContainer = styled.div`
  /* width: 3.125rem;
  height: 3.125rem; */
  height: fit-content;
  border-radius: 50%;
  /* border: 2px solid red; */
`;

const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0.875rem;
  border-top: 1px solid ${({ theme }) => theme.palette.borderColor};
`;

const BottomSectionLabel = styled.div`
  font-size: 1.25rem;
  font-weight: 400;
  line-height: normal;
  color: ${({ theme }) => theme.palette.greyGrey2};
`;

const BottomSectionData = styled.div`
  font-size: 1.25rem;
  font-weight: 400;
  line-height: normal;
  color: ${({ theme }) => theme.palette.blackBlackMain};
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
